module.exports = __webpack_public_path__ + "static/img/top_pic@2x.8a3e379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_pic@2x.png
// module id = ZXH3
// module chunks = 1